import { useQuery } from '@hooks/reactQuery';

import { getAssets } from '@api/assets';

import { extractQueryParams } from '@utils/common';

import { TGetAssetsDTO } from '@interfaces/assets/dto/assetsDTO';

import { ASSETS_LIST } from '@constants/queryKeys';

interface IUseAssetsListParams extends TGetAssetsDTO {
	closeDeleteConfirm?: () => void;
	closeModals?: () => void;
	isAdminPanel?: boolean;
}

export const useQueryAssetsList = (params?: IUseAssetsListParams) => {
	const {
		pageSize,
		page,
		sortDirection,
		sortFieldName,
		searchValue,
		assetTypeId,
		assetSubTypeId,
		contactPersonId,
		isAvailable,
		backhaulAccessibilityStatus,
		assetSiteAvailabilityStatus,
		powerSupplyAvailabilityStatus,
		createdAt,
		updatedAt,
		lastVerificationDate,
		isAdminPanel = false,
		rentStatus,
	} = params || {};

	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [
			ASSETS_LIST,
			{
				page,
				pageSize,
				sortDirection,
				sortFieldName,
				searchValue,
				assetTypeId,
				assetSubTypeId,
				contactPersonId,
				isAvailable,
				backhaulAccessibilityStatus,
				assetSiteAvailabilityStatus,
				powerSupplyAvailabilityStatus,
				createdAt,
				updatedAt,
				lastVerificationDate,
				rentStatus,
			},
		],
		queryFn: extractQueryParams(getAssets),
		refetchOnWindowFocus: false,
		enabled: [isAdminPanel],
	});

	return {
		assetsList: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingAssets: isInitialLoading,
	};
};
